module.exports = __webpack_public_path__ + "img/cycle-2_c.a0d9fee6.png";